import request from '@/utils/zsm-requets'
/* 参数设置-获取特定key对应的value */
export function settingConfig(key) {
    return request({
      url: '/zsm/api/setting/config',
      method: 'post',
      params: { key }
    })
  }
  
